var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoneControl13Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1236,
    height: 745,
    viewBox: "0 0 1236 745",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M772.6 665.433L897.627 737.557V679.874L772.6 607.758V665.433Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M772.6 607.758L897.627 679.874L1037.26 599.247L912.237 527.131L772.6 607.758Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.27 599.247V656.93L897.629 737.557V679.874L1037.27 599.247Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.59 612.553V652.499L905.309 724.257V684.305L1029.59 612.553Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M994.83 632.614L1029.59 612.553V652.499L1029.43 652.593L994.83 632.614Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_935_3727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 905,
    y: 612,
    width: 125,
    height: 113
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.59 612.553V652.499L905.309 724.257V684.305L1029.59 612.553Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_935_3727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.338 580.741L1018.34 640.787L1023.75 637.66L919.755 577.613L914.338 580.741Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.338 586.988L1018.34 647.028V640.773L914.338 580.734V586.988Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.34 647.028L1023.75 643.901V637.646L1018.34 640.773V647.028Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.098 586.712L1008.1 646.758L1013.52 643.631L909.515 583.584L904.098 586.712Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.098 592.959L1008.1 652.999V646.744L904.098 586.705V592.959Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.1 652.999L1013.52 649.871V643.617L1008.1 646.744V652.999Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.863 592.581L997.858 652.627L1003.28 649.5L899.28 589.454L893.863 592.581Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.859 598.822L997.861 658.868V652.614L893.859 592.567V598.822Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.861 658.868L1003.28 655.741V649.487L997.861 652.614V658.868Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.625 598.552L987.62 658.598L993.037 655.471L889.042 595.425L883.625 598.552Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.625 604.793L987.62 664.839V658.585L883.625 598.538V604.793Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.621 664.839L993.038 661.712V655.458L987.621 658.585V664.839Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.385 604.469L977.38 664.515L982.797 661.388L878.802 601.341L873.385 604.469Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.385 610.716L977.38 670.756V664.501L873.385 604.462V610.716Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.383 670.756L982.8 667.629V661.374L977.383 664.501V670.756Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.146 610.311L967.148 670.351L972.565 667.223L868.563 607.184L863.146 610.311Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.146 616.552L967.148 676.598V670.344L863.146 610.297V616.552Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.146 676.598L972.563 673.471V667.217L967.146 670.344V676.598Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914 616.39L956.909 676.43L962.326 673.302L858.331 613.263L852.914 616.39Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.908 622.631L956.91 682.677V676.423L852.915 616.376L852.908 622.631Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.91 682.677L962.327 679.55V673.296L956.91 676.423V682.677Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.676 622.233L946.671 682.279L952.088 679.152L848.093 619.105L842.676 622.233Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.676 628.48L946.671 688.527V682.265L842.676 622.226V628.48Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.668 688.526L952.085 685.399V679.138L946.668 682.265V688.526Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.436 628.156L936.437 688.203L941.847 685.075L837.852 625.029L832.436 628.156Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.436 634.397L936.43 694.444V688.189L832.436 628.143V634.397Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.432 694.444L941.849 691.316V685.062L936.432 688.189V694.444Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.197 634.033L926.199 694.079L931.616 690.952L827.614 630.905L822.197 634.033Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.197 640.28L926.199 700.32V694.065L822.197 634.026V640.28Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.199 700.32L931.616 697.193V690.938L926.199 694.065V700.32Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.965 639.949L915.96 699.996L921.377 696.868L817.382 636.822L811.965 639.949Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.965 646.197L915.96 706.237V699.982L811.965 639.943V646.197Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.957 706.237L921.374 703.109V696.855L915.957 699.982V706.237Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.77 305.222V321.737L1032.29 315.644L1043.03 306.236L1053.77 305.222Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M837.61 196.929V180.415L820.771 183.725L821.683 196.929H837.61Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M837.61 180.415L555.729 17.6617L2.61133 337.015L191.541 446.098L150.218 469.962L553.378 702.738L594.701 678.875L680.615 728.479H783.502L1233.73 468.53V409.125L1103.87 334.145C1090.04 342.135 1067.61 342.135 1053.77 334.145C1039.94 326.154 1039.94 313.206 1053.77 305.222L887.706 209.344C873.874 217.335 851.443 217.335 837.61 209.344C823.777 201.354 823.777 188.406 837.61 180.422V180.415Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.049 454.366L165.132 478.573L153.961 472.123L195.884 447.922L207.049 454.366Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M223.739 464.004L181.815 488.205L170.65 481.761L212.574 457.554L223.739 464.004Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.428 473.636L198.505 497.843L187.34 491.393L229.263 467.193L240.428 473.636Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.12 483.275L215.196 507.475L204.031 501.031L245.955 476.824L257.12 483.275Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M273.809 492.913L231.885 517.113L220.721 510.663L262.637 486.463L273.809 492.913Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M290.498 502.545L248.575 526.752L237.41 520.302L279.327 496.101L290.498 502.545Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.188 512.183L265.264 536.384L254.1 529.94L296.016 505.733L307.188 512.183Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M323.868 521.815L281.951 546.022L270.779 539.572L312.703 515.371L323.868 521.815Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M340.559 531.453L298.642 555.654L287.471 549.21L329.394 525.003L340.559 531.453Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.25 541.092L315.334 565.292L304.162 558.842L346.086 534.642L357.25 541.092Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M373.94 550.724L332.016 574.931L320.852 568.481L362.775 544.28L373.94 550.724Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M390.627 560.362L348.704 584.563L337.539 578.119L379.463 553.912L390.627 560.362Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M407.319 569.994L365.395 594.201L354.23 587.751L396.147 563.55L407.319 569.994Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M424.008 579.632L382.085 603.833L370.92 597.389L412.837 573.182L424.008 579.632Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M440.698 589.271L398.774 613.471L387.609 607.021L429.526 582.821L440.698 589.271Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M457.381 598.903L415.464 623.11L404.293 616.66L446.216 592.459L457.381 598.903Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M474.071 608.541L432.154 632.742L420.982 626.298L462.906 602.091L474.071 608.541Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M490.76 618.173L448.843 642.38L437.672 635.93L479.595 611.729L490.76 618.173Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M507.45 627.811L465.526 652.012L454.361 645.568L496.285 621.361L507.45 627.811Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M524.139 637.45L482.216 661.65L471.051 655.2L512.974 631L524.139 637.45Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M540.828 647.082L498.905 671.289L487.74 664.839L529.657 640.638L540.828 647.082Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M557.518 656.72L515.594 680.921L504.43 674.477L546.346 650.27L557.518 656.72Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M574.207 666.352L532.284 690.559L521.119 684.109L563.036 659.908L574.207 666.352Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M590.891 675.99L548.974 700.191L537.803 693.747L579.726 669.54L590.891 675.99Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M759.337 618.382L137.312 259.245L168.308 241.346L790.332 600.49L857.692 600.504L1103.57 458.547L1134.55 476.439L888.687 618.396L759.337 618.382Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M594.702 678.875V695.396L553.373 719.252V702.738L594.702 678.875Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M783.502 728.479H680.615V745H783.502V728.479Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.73 468.53V485.051L783.502 745V728.479L1233.73 468.53Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M572.695 474.832L850.916 312.828V269.188L922.315 229.317",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M323.674 151.641L483.79 244.264V319.609L662.29 422.661",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M340.803 141.368L500.912 233.991V309.336L679.419 412.388",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M359.723 131.513L519.832 224.143V299.488L698.339 402.54",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M376.844 121.24L536.96 213.87V289.215L715.46 392.259",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M394.83 110.973L554.939 203.603V278.948L733.447 381.993",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M684.566 539.424L772.601 486.348H904.93L1135.54 352.078",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M254.099 326.668L153.961 384.127",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M474.071 453.792L373.939 511.244",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M490.76 463.424L390.629 520.883",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M507.45 473.062L407.318 530.515",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M631.33 544.456L531.191 601.915",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M491.201 186.156L494.16 189.709L495.774 188.77V170.108L491.201 172.749V186.156Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M489.586 187.095L494.159 189.709V171.047L489.586 173.688V187.095Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M495.771 170.108L488.706 174.188L484.127 171.58L491.199 167.494L495.771 170.108Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M488.706 174.188V176.058L484.127 173.445V171.58L488.706 174.188Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M471.152 177.625V196.693L491.793 184.778V165.704L471.152 177.625Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M378.295 124.009L471.152 177.626L491.793 165.704L398.943 112.095L378.295 124.009Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M378.295 143.084V124.009L471.152 177.626V196.693L378.295 143.084Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M454.49 207.304V188.885L461.467 184.86L465.945 187.467L458.968 191.499V209.911L454.49 207.304Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M458.971 209.911V191.499L465.948 187.467V189.284L460.524 192.411V209.013L458.971 209.911Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M458.968 191.499L454.49 188.885V207.304L458.968 209.911V191.499Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M441.778 200.07L441.771 181.651L448.755 177.626L453.227 180.233L446.25 184.265V202.677L441.778 200.07Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M446.25 202.677V184.265L453.227 180.233V182.05L447.81 185.177V201.772L446.25 202.677Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M446.25 184.265L441.771 181.651L441.778 200.07L446.25 202.677V184.265Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 192.762V174.343L436.036 170.317L440.514 172.925L433.537 176.957V195.369L429.059 192.762Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M433.539 195.369V176.957L440.516 172.924V174.741L435.093 177.869V194.464L433.539 195.369Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M433.537 176.957L429.059 174.343V192.762L433.537 195.369V176.957Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M416.352 185.372V166.954L423.329 162.928L427.807 165.535L420.83 169.561V187.98L416.352 185.372Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M420.826 187.979V169.561L427.803 165.535V167.352L422.38 170.479V187.074L420.826 187.979Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M420.83 169.561L416.352 166.954V185.372L420.83 187.98V169.561Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M403.631 177.976V159.564L410.608 155.532L415.086 158.146L408.109 162.171V180.59L403.631 177.976Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M408.109 180.59V162.171L415.087 158.146V159.963L409.663 163.09V179.685L408.109 180.59Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M408.109 162.171L403.631 159.564V177.976L408.109 180.59V162.171Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M390.918 170.668V152.249L397.895 148.224L402.373 150.831L395.396 154.863V173.275L390.918 170.668Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M395.396 173.275V154.863L402.374 150.831V152.648L396.95 155.782V172.377L395.396 173.275Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M395.396 154.863L390.918 152.249V170.668L395.396 173.275V154.863Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M378.201 163.279V144.86L385.178 140.835L389.656 143.442L382.679 147.474V165.886L378.201 163.279Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M382.68 165.886V147.474L389.657 143.442V145.259L384.24 148.386V164.988L382.68 165.886Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M382.679 147.474L378.201 144.86V163.279L382.679 165.886V147.474Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M875.286 518.688C875.286 518.688 869.113 522.416 870.193 528.11C871.274 533.804 881.777 530.076 883.546 524.28C885.316 518.485 880.082 515.446 875.286 518.681V518.688Z",
    fill: "black"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M569.176 267.715V287.654L683.234 353.51H714.128L828.187 287.654V266.425L714.128 203.961H683.234L569.176 267.715Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M569.176 249.877V267.715L683.234 333.571H714.128L828.187 267.715V249.877L714.128 184.022H683.234L569.176 249.877Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M588.357 251.201V266.398L685.517 322.493H711.838L809.005 266.398V251.201L711.838 195.099H685.517L588.357 251.201Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M750.803 272.606L686.496 235.477L693.176 231.62L757.483 268.749L750.803 272.606Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M741.475 277.989L677.168 240.86L683.848 237.003L748.155 274.132L741.475 277.989Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M732.157 283.372L667.85 246.243L674.53 242.387L738.837 279.515L732.157 283.372Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M722.834 288.755L658.527 251.627L665.201 247.77L729.514 284.899L722.834 288.755Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M713.506 294.139L649.199 257.01L655.879 253.153L720.186 290.282L713.506 294.139Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M704.188 299.522L639.881 262.393L646.561 258.536L710.868 295.665L704.188 299.522Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M742.051 359.473L736.215 356.103L728.617 342.939L722.659 339.501L717.107 342.716L723.058 346.154L730.663 359.325L736.492 362.695L742.051 359.473Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M767.283 345.12L761.454 341.75L753.849 328.579L747.899 325.148L742.34 328.363L748.297 331.801L755.896 344.972L761.731 348.335L767.283 345.12Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M792.527 330.45L786.692 327.079L779.093 313.915L773.136 310.478L767.584 313.693L773.535 317.13L781.14 330.301L786.969 333.672L792.527 330.45Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M817.76 316.022L811.931 312.659L804.326 299.488L798.375 296.05L792.816 299.272L798.774 302.703L806.372 315.874L812.208 319.244L817.76 316.022Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M843 301.352L837.164 297.988L829.566 284.818L823.609 281.38L818.057 284.601L824.007 288.039L831.612 301.203L837.441 304.574L843 301.352Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M735.993 339.994L743.599 353.165L749.428 356.528L754.986 353.313V352.395L749.151 349.943L741.552 336.772L735.595 333.341L730.043 335.644V336.556",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M754.986 352.395L749.151 349.031L741.552 335.86L735.595 332.422L730.043 335.644L735.993 339.075L743.599 352.246L749.428 355.616L754.986 352.395Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M780.219 337.724L774.39 334.361L766.785 321.19L760.834 317.752L755.275 320.974L761.233 324.412L768.831 337.576L774.667 340.946L780.219 337.724Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M805.461 323.304L799.625 319.933L792.027 306.762L786.07 303.325L780.518 306.546L786.468 309.984L794.073 323.155L799.902 326.519L805.461 323.304Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M830.695 308.633L824.866 305.263L817.261 292.092L811.311 288.661L805.752 291.876L811.709 295.314L819.308 308.485L825.143 311.848L830.695 308.633Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M655.012 359.473L660.841 356.103L668.446 342.939L674.396 339.501L679.955 342.716L674.005 346.154L666.399 359.325L660.564 362.695L655.012 359.473Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M629.77 345.12L635.605 341.75L643.21 328.579L649.161 325.148L654.713 328.363L648.762 331.801L641.157 344.972L635.328 348.335L629.77 345.12Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M604.535 330.45L610.364 327.079L617.969 313.915L623.92 310.478L629.479 313.693L623.528 317.13L615.923 330.301L610.087 333.672L604.535 330.45Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M579.293 316.022L585.129 312.659L592.734 299.488L598.684 296.05L604.236 299.272L598.286 302.703L590.681 315.874L584.852 319.244L579.293 316.022Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M554.059 301.352L559.887 297.988L567.493 284.818L573.443 281.38L579.002 284.601L573.051 288.039L565.446 301.203L559.611 304.574L554.059 301.352Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M642.074 352.395L647.903 349.031L655.508 335.86L661.459 332.422L667.018 335.644L661.067 339.075L653.462 352.246L647.626 355.616L642.074 352.395Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M616.834 337.724L622.67 334.361L630.275 321.19L636.225 317.752L641.777 320.974L635.827 324.412L628.222 337.576L622.393 340.946L616.834 337.724Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M591.6 323.304L597.428 319.933L605.034 306.762L610.984 303.325L616.543 306.546L610.593 309.984L602.987 323.155L597.152 326.519L591.6 323.304Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M566.359 308.633L572.195 305.263L579.8 292.092L585.751 288.661L591.303 291.876L585.352 295.314L577.747 308.484L571.918 311.848L566.359 308.633Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.03 375.32L981.98 427.889V352.551L1073.03 299.981V375.32Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M997.968 399.716L991.666 403.357V398.115L997.968 394.475V387.295L1002.53 384.661V391.841L1008.83 388.2V393.441L1002.53 397.082V404.147L997.968 406.781V399.716Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.78 371.307V365.201L1063.36 359.676V365.782L1053.78 371.307Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M973.525 343.162L983.488 348.91L988.094 346.255L978.132 340.501L973.525 343.162Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M993.113 331.902L1003.07 337.65L1007.68 334.989L997.72 329.241L993.113 331.902Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.7 320.575L1022.65 326.33L1027.26 323.669L1017.31 317.921L1012.7 320.575Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M983.381 337.529L993.343 343.283L997.95 340.622L987.987 334.874L983.381 337.529Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.97 326.269L1012.92 332.024L1017.54 329.363L1007.57 323.608L1002.97 326.269Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.55 314.949L1032.51 320.697L1037.12 318.036L1027.16 312.288L1022.55 314.949Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M550.325 584.786L545.064 581.753L538.35 585.63L533.197 582.658L528.293 585.502L533.446 588.474L540.16 584.597L545.422 587.63L550.325 584.786Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M562.382 577.579L557.12 574.547L550.407 578.424L545.253 575.452L540.35 578.295L545.503 581.267L552.224 577.39L557.478 580.423L562.382 577.579Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M574.878 570.433L569.623 567.394L562.903 571.277L557.749 568.299L552.846 571.142L557.999 574.121L564.72 570.244L569.974 573.277L574.878 570.433Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M586.847 563.638L581.592 560.599L574.872 564.476L569.718 561.504L564.814 564.347L569.968 567.319L576.688 563.442L581.943 566.482L586.847 563.638Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M536.46 592.601L531.198 589.562L524.485 593.438L519.331 590.467L514.428 593.31L519.581 596.282L526.295 592.405L531.556 595.444L536.46 592.601Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M613.263 548.447L608.008 545.415L601.288 549.292L596.134 546.313L591.23 549.163L596.384 552.135L603.104 548.258L608.359 551.291L613.263 548.447Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M625.325 541.241L620.064 538.208L613.343 542.085L608.197 539.106L603.293 541.95L608.44 544.928L615.16 541.052L620.422 544.084L625.325 541.241Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M637.819 534.095L632.558 531.055L625.844 534.932L620.691 531.96L615.787 534.804L620.941 537.782L627.654 533.899L632.916 536.938L637.819 534.095Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M599.396 556.256L594.141 553.223L587.42 557.1L582.267 554.128L577.363 556.972L582.517 559.943L589.237 556.066L594.492 559.099L599.396 556.256Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M676.542 577.329L570.838 638.355V609.46L676.542 548.427V577.329Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M676.542 548.427L570.838 609.46L530.84 586.36L636.537 525.334L676.542 548.427Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M570.839 604.995L538.574 586.367L636.538 529.806L668.803 548.434L570.839 604.995ZM541.33 586.36L570.839 603.394L666.047 548.421L636.538 531.386L541.33 586.36Z",
    fill: "#FBB93E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M530.84 586.36V615.262L570.838 638.355V609.46L530.84 586.36Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M599.166 636.734L594.127 633.816L587.549 622.428L582.402 619.456L577.6 622.246L582.746 625.218L589.325 636.605L594.364 639.517L599.166 636.734Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M620.99 624.319L615.951 621.408L609.373 610.021L604.226 607.049L599.424 609.831L604.571 612.803L611.142 624.191L616.188 627.102L620.99 624.319Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M642.812 611.635L637.774 608.724L631.195 597.336L626.048 594.364L621.246 597.147L626.393 600.119L632.965 611.506L638.01 614.417L642.812 611.635Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M664.635 599.159L659.589 596.248L653.017 584.861L647.871 581.889L643.068 584.671L648.215 587.643L654.787 599.031L659.832 601.942L664.635 599.159Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M686.457 586.474L681.411 583.563L674.84 572.176L669.693 569.204L664.891 571.987L670.037 574.958L676.609 586.346L681.655 589.257L686.457 586.474Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M610.353 630.608L605.315 627.697L598.736 616.309L593.589 613.337L588.787 616.127L593.934 619.098L600.506 630.486L605.551 633.397L610.353 630.608Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M632.174 617.93L627.135 615.012L620.556 603.624L615.41 600.652L610.607 603.442L615.754 606.414L622.326 617.801L627.371 620.712L632.174 617.93Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M653.996 605.454L648.951 602.543L642.379 591.155L637.232 588.184L632.43 590.966L637.576 593.938L644.148 605.326L649.194 608.237L653.996 605.454Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M675.82 592.769L670.775 589.858L664.203 578.471L659.056 575.499L654.254 578.282L659.401 581.253L665.973 592.641L671.018 595.552L675.82 592.769Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M642.067 637.936L636.806 634.897L630.092 638.774L624.939 635.802L620.035 638.646L625.189 641.617L631.902 637.741L637.164 640.78L642.067 637.936Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M654.126 630.723L648.865 627.69L642.151 631.567L636.997 628.595L632.094 631.439L637.247 634.41L643.961 630.533L649.223 633.573L654.126 630.723Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M666.62 623.577L661.365 620.544L654.645 624.421L649.491 621.442L644.588 624.286L649.741 627.265L656.462 623.388L661.717 626.42L666.62 623.577Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M678.589 616.782L673.327 613.742L666.614 617.626L661.46 614.647L656.557 617.491L661.71 620.469L668.424 616.586L673.685 619.625L678.589 616.782Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M628.202 645.744L622.941 642.705L616.22 646.582L611.074 643.61L606.17 646.454L611.323 649.426L618.037 645.549L623.299 648.588L628.202 645.744Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M705.003 601.591L699.748 598.558L693.028 602.435L687.874 599.463L682.971 602.307L688.124 605.279L694.845 601.402L700.099 604.434L705.003 601.591Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M717.06 594.384L711.805 591.351L705.084 595.228L699.931 592.257L695.027 595.1L700.181 598.072L706.901 594.195L712.163 597.228L717.06 594.384Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M729.566 588.076V587.238L719.4 587.042L717.584 588.082L712.437 585.948L707.533 587.947V588.792L712.687 591.763L719.4 587.886L724.662 590.919L729.566 588.076Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M729.566 587.238L724.304 584.199L717.584 588.082L712.437 585.104L707.533 587.947L712.687 590.926L719.4 587.042L724.662 590.082L729.566 587.238Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M691.138 609.399L685.883 606.366L679.162 610.243L674.009 607.271L669.105 610.115L674.259 613.087L680.979 609.21L686.234 612.249L691.138 609.399Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M768.286 630.473L662.582 691.499V662.603L768.286 601.578V630.473Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M768.284 601.578L662.581 662.603L622.582 639.51L728.279 578.478L768.284 601.578Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M662.583 658.139L630.318 639.51L728.282 582.949L760.547 601.578L662.583 658.139ZM633.074 639.51L662.583 656.545L757.798 601.571L728.289 584.536L633.074 639.51Z",
    fill: "#FBB93E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M622.582 639.51V668.405L662.581 691.499V662.603L622.582 639.51Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M690.908 689.877L685.869 686.966L679.291 675.579L674.144 672.607L669.342 675.39L674.489 678.361L681.06 689.749L686.106 692.66L690.908 689.877Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M712.73 677.463L707.692 674.552L701.113 663.164L695.966 660.192L691.164 662.975L696.311 665.947L702.883 677.334L707.928 680.245L712.73 677.463Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M734.553 664.778L729.514 661.867L722.935 650.479L717.789 647.507L712.986 650.29L718.133 653.262L724.705 664.65L729.75 667.561L734.553 664.778Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M756.375 652.303L751.329 649.391L744.758 638.004L739.611 635.032L734.809 637.815L739.955 640.787L746.527 652.174L751.573 655.092L756.375 652.303Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M778.199 639.618L773.154 636.707L766.582 625.319L761.435 622.347L756.633 625.13L761.78 628.102L768.351 639.49L773.397 642.407L778.199 639.618Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M702.092 683.758L697.053 680.847L690.474 669.459L685.328 666.487L680.525 669.27L685.672 672.242L692.244 683.629L697.289 686.54L702.092 683.758Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M723.918 671.073L718.872 668.162L712.301 656.774L707.154 653.802L702.352 656.585L707.498 659.557L714.07 670.945L719.116 673.856L723.918 671.073Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M745.738 658.598L740.693 655.687L734.121 644.299L728.974 641.327L724.172 644.11L729.319 647.082L735.89 658.469L740.936 661.381L745.738 658.598Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M767.563 645.913L762.518 643.002L755.946 631.614L750.799 628.642L745.99 631.425L751.144 634.397L757.716 645.784L762.761 648.696L767.563 645.913Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M818.632 429.456V428.719L804.725 420.682L798.653 424.194L798.309 424.39L812.857 432.792L818.632 429.456Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M804.083 420.324L798.309 423.654L812.857 432.056L818.632 428.719L804.083 420.324Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M798.309 423.654V424.39L812.857 432.792V432.056L798.309 423.654Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M815.416 440.709L764.604 469.901V448.8L815.416 419.608V440.709Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M815.417 419.608L764.605 448.8L735.393 431.935L786.205 402.742L815.417 419.608Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M735.393 431.935V453.035L764.605 469.901V448.8L735.393 431.935Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M741.322 456.467L735.547 459.803L750.095 468.199L755.87 464.869L741.322 456.467Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M755.871 464.869L741.322 456.466V440.925L755.871 449.32V464.869Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M784.5 458.472L791.025 454.724V433.704L784.5 437.385V458.472Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M755.27 420.513L761.74 416.798L791.026 433.704L784.502 437.385L755.27 420.513Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M486.235 368.558V369.626L465.014 381.878V380.811L486.235 368.558Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M461.285 393.428L495.995 413.171V382.391L461.285 362.648V393.428Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M461.285 362.648L495.995 382.391L538.601 357.785L503.891 338.049L461.285 362.648Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M538.6 357.785V388.565L495.994 413.171V382.391L538.6 357.785Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M529.946 393.57L538.376 398.433L517.154 410.685L508.725 405.822L529.946 393.57Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M508.725 405.829L529.946 393.576V370.895L508.725 383.148V405.829Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2999 325.371V326.438L70.0781 338.697V337.623L91.2999 325.371Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3457 350.24L101.056 369.983V339.204L66.3457 319.461V350.24Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3457 319.461L101.056 339.204L143.668 314.598L108.958 294.861L66.3457 319.461Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M143.669 314.598V345.377L101.057 369.983V339.204L143.669 314.598Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M135.015 350.382L143.437 355.245L122.215 367.498L113.793 362.635L135.015 350.382Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M113.793 362.642L135.015 350.389V327.708L113.793 339.967V362.642Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M503.91 343.216L529.583 357.812L495.981 377.217L470.308 362.621L503.91 343.216ZM503.89 338.049L461.277 362.648L495.987 382.385L538.6 357.785L503.89 338.049Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M503.91 348.39L525.071 360.419L529.583 357.819L503.91 343.216L470.301 362.621L474.813 365.187L503.91 348.39Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M398.143 312.558C409.876 319.332 409.876 330.315 398.143 337.09C386.411 343.864 367.385 343.864 355.653 337.09C343.92 330.315 343.92 319.332 355.653 312.558C367.385 305.783 386.411 305.783 398.143 312.558Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M355.655 321.392C367.387 314.618 386.414 314.618 398.146 321.392C402.05 323.648 404.623 326.37 405.927 329.241C408.548 323.472 405.974 317.076 398.146 312.558C386.414 305.783 367.387 305.783 355.655 312.558C347.827 317.076 345.247 323.472 347.874 329.241C349.185 326.363 351.758 323.641 355.655 321.392Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M596.793 414.225C607.526 420.418 607.526 430.462 596.793 436.663C586.061 442.856 568.662 442.856 557.936 436.663C547.204 430.469 547.204 420.425 557.936 414.225C568.669 408.031 586.061 408.031 596.793 414.225Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M549.887 425.443V403.039H604.839V425.443",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M549.887 425.443V403.039H604.839V425.443",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M596.793 391.82C607.526 398.014 607.526 408.058 596.793 414.258C586.061 420.452 568.662 420.452 557.936 414.258C547.204 408.065 547.204 398.021 557.936 391.82C568.669 385.627 586.061 385.627 596.793 391.82Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M594.264 391.212C603.591 396.602 603.591 405.335 594.264 410.719C584.936 416.108 569.807 416.108 560.472 410.719C551.145 405.329 551.145 396.596 560.472 391.212C569.8 385.823 584.929 385.823 594.264 391.212Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M601.259 389.929H553.473V400.972H601.259V389.929Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M596.793 382.499C607.526 388.693 607.526 398.737 596.793 404.937C586.061 411.131 568.662 411.131 557.936 404.937C547.204 398.744 547.204 388.7 557.936 382.499C568.669 376.306 586.061 376.306 596.793 382.499Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M549.887 393.718V337.184H604.839V393.718",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M549.887 393.718V337.184H604.839V393.718",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M596.793 325.972C607.526 332.166 607.526 342.209 596.793 348.41C586.061 354.604 568.662 354.604 557.936 348.41C547.204 342.216 547.204 332.172 557.936 325.972C568.669 319.778 586.061 319.778 596.793 325.972Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M592.128 328.66C600.28 333.368 600.28 341 592.128 345.708C583.976 350.415 570.751 350.415 562.599 345.708C554.446 341 554.446 333.368 562.599 328.66C570.751 323.952 583.976 323.952 592.128 328.66Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M562.598 334.8C570.75 330.092 583.975 330.092 592.127 334.8C594.842 336.367 596.626 338.258 597.537 340.257C599.361 336.245 597.571 331.808 592.127 328.66C583.975 323.952 570.75 323.952 562.598 328.66C557.154 331.801 555.364 336.245 557.188 340.257C558.093 338.258 559.883 336.367 562.598 334.8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M587.618 58.3028C609.955 71.1969 609.955 92.1084 587.618 105.003C565.282 117.897 529.073 117.897 506.737 105.003C484.4 92.1084 484.4 71.1969 506.737 58.3028C529.073 45.4087 565.282 45.4087 587.618 58.3028Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M489.984 81.6527V35.0205H604.367V81.6527",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M489.984 81.6527V35.0205H604.367V81.6527",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M587.618 11.6706C609.955 24.5647 609.955 45.4762 587.618 58.3703C565.282 71.2645 529.073 71.2645 506.737 58.3703C484.4 45.4762 484.4 24.5647 506.737 11.6706C529.073 -1.22353 565.282 -1.22353 587.618 11.6706Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M582.343 14.7167C601.761 25.929 601.761 44.1117 582.343 55.324C562.924 66.5363 531.436 66.5363 512.011 55.324C492.593 44.1117 492.593 25.929 512.011 14.7167C531.429 3.50443 562.918 3.50443 582.343 14.7167Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M512.011 25.6318C531.429 14.4196 562.917 14.4196 582.343 25.6318C589.637 29.8466 594.189 35.0407 596.006 40.4779C599.025 31.4338 594.473 21.721 582.343 14.7168C562.924 3.50449 531.436 3.50449 512.011 14.7168C499.887 21.721 495.335 31.4338 498.347 40.4779C500.164 35.0407 504.716 29.8466 512.011 25.6318Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M587.617 78.0459C565.281 90.94 529.071 90.94 506.735 78.0459C495.57 71.5954 489.984 63.1457 489.984 54.696V68.3128C489.984 76.7625 495.57 85.2123 506.735 91.6627C529.071 104.557 565.281 104.557 587.617 91.6627C598.782 85.2123 604.367 76.7625 604.367 68.3128V54.696C604.367 63.1457 598.782 71.5954 587.617 78.0459Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M378.458 187.291C372.454 183.826 364.599 181.915 356.338 181.915C348.078 181.915 340.223 183.826 334.218 187.291L248.183 236.963C241.26 240.961 237.295 246.858 237.295 253.14C237.295 259.421 241.266 265.318 248.183 269.316C254.187 272.781 262.042 274.693 270.303 274.693C278.563 274.693 286.418 272.781 292.423 269.316L378.458 219.645C385.381 215.646 389.346 209.749 389.346 203.468C389.346 197.186 385.375 191.283 378.458 187.291Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M378.458 174.748C372.454 171.283 364.599 169.372 356.338 169.372C348.078 169.372 340.223 171.283 334.218 174.748L248.183 224.42C241.26 228.419 237.295 234.315 237.295 240.597C237.295 246.878 241.266 252.775 248.183 256.773C254.187 260.238 262.042 262.15 270.303 262.15C278.563 262.15 286.418 260.238 292.423 256.773L378.458 207.102C385.381 203.103 389.346 197.207 389.346 190.925C389.346 184.643 385.375 178.74 378.458 174.748Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M383.208 188.966H383.228V93.5472L243.26 146.116V239.955C243.233 240.387 243.233 240.813 243.26 241.245V241.529H243.281C243.659 245.21 246.259 248.844 251.143 251.667C261.727 257.78 278.889 257.78 289.473 251.667L375.508 201.995C381.668 198.443 384.215 193.6 383.208 188.966Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M337.169 84.4423L251.133 134.114C240.549 140.227 240.549 150.135 251.133 156.248C261.717 162.361 278.88 162.361 289.463 156.248L375.499 106.576C386.083 100.464 386.083 90.555 375.499 84.4423C364.915 78.3295 347.752 78.3295 337.169 84.4423Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M310.045 278.455V277.739L305.499 275.834L299.569 265.568L294.929 262.886L290.6 264.683V265.399L295.24 268.073L301.163 278.34L305.716 280.967L310.045 278.455Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M310.045 277.739L305.499 275.118L299.569 264.852L294.929 262.17L290.6 264.683L295.24 267.364L301.163 277.624L305.716 280.251L310.045 277.739Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M329.712 267.269V266.553L325.167 264.642L319.243 254.376L314.603 251.701L310.273 253.491V254.207L314.914 256.888L320.837 267.155L325.383 269.775L329.712 267.269Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M329.712 266.553L325.167 263.926L319.243 253.66L314.603 250.985L310.273 253.491L314.914 256.172L320.837 266.439L325.383 269.059L329.712 266.553Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M349.389 255.834V255.118L344.843 253.207L338.913 242.94L334.273 240.266L329.943 242.056V242.772L334.584 245.453L340.514 255.719L345.059 258.34L349.389 255.834Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M349.389 255.118L344.843 252.491L338.913 242.224L334.273 239.55L329.943 242.056L334.584 244.737L340.514 255.003L345.059 257.624L349.389 255.118Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M369.063 244.588V243.872L364.517 241.961L358.587 231.694L353.947 229.02L349.617 230.816V231.526L354.257 234.207L360.181 244.473L364.733 247.094L369.063 244.588Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M369.063 243.872L364.517 241.252L358.587 230.985L353.947 228.304L349.617 230.816L354.257 233.491L360.181 243.757L364.733 246.385L369.063 243.872Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M388.732 233.153V232.437L384.186 230.526L378.263 220.259L373.622 217.585L369.293 219.374V220.09L373.933 222.772L379.857 233.038L384.402 235.659L388.732 233.153Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M388.732 232.437L384.186 229.816L378.263 219.55L373.622 216.869L369.293 219.374L373.933 222.056L379.857 232.322L384.402 234.95L388.732 232.437Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M379.857 232.323L384.187 229.817L388.732 232.437L384.403 234.95L379.857 232.323Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M320.129 272.943V272.227L315.577 270.316L309.653 260.049L305.013 257.368L300.684 259.164V259.88L305.324 262.562L311.247 272.821L315.793 275.449L320.129 272.943Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M320.129 272.227L315.577 269.6L309.653 259.333L305.013 256.659L300.684 259.164L305.324 261.846L311.247 272.112L315.793 274.733L320.129 272.227Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M339.797 261.508V260.792L335.251 258.88L329.328 248.614L324.688 245.933L320.352 247.729V248.445L324.992 251.127L330.922 261.386L335.468 264.014L339.797 261.508Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M339.797 260.792L335.251 258.165L329.328 247.898L324.688 245.223L320.352 247.729L324.992 250.411L330.922 260.677L335.468 263.298L339.797 260.792Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M359.473 250.262V249.546L354.927 247.635L348.997 237.368L344.357 234.693L340.027 236.483V237.199L344.667 239.881L350.591 250.147L355.143 252.768L359.473 250.262Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M359.473 249.546L354.927 246.919L348.997 236.652L344.357 233.977L340.027 236.483L344.667 239.165L350.591 249.431L355.143 252.052L359.473 249.546Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M379.14 238.827V238.111L374.594 236.199L368.671 225.933L364.031 223.258L359.701 225.048V225.764L364.341 228.445L370.265 238.712L374.81 241.333L379.14 238.827Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M379.14 238.111L374.594 235.483L368.671 225.217L364.031 222.542L359.701 225.048L364.341 227.729L370.265 237.996L374.81 240.617L379.14 238.111Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M383.222 175.775V170.797C382.519 174.154 379.959 177.403 375.501 179.976L289.466 229.648C278.882 235.761 261.72 235.761 251.136 229.648C246.131 226.757 243.517 223.015 243.247 219.226V226.77C243.22 227.203 243.22 227.628 243.247 228.061V228.344H243.267C243.645 232.025 246.246 235.659 251.129 238.483C261.713 244.595 278.875 244.595 289.459 238.483L375.495 188.811C381.655 185.258 384.201 180.415 383.194 175.782H383.215L383.222 175.775Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.53 437.115H1192.54L1192.53 429.057L1189.56 430.266C1188.42 429.044 1186.98 427.889 1185.2 426.855C1176.95 422.094 1164.41 421.351 1154.79 424.599L1154.75 424.579L1086.15 443.485C1085.49 443.654 1084.84 443.836 1084.19 444.018L1083 444.349L1083.02 444.363C1078.48 445.754 1074.21 447.558 1070.39 449.766C1066.59 451.961 1063.48 454.407 1061.08 457.014L1061.05 457.048C1060.35 457.804 1059.72 458.581 1059.14 459.364L1029.44 495.298L1023.4 497.749V505.807C1023.4 506.003 1023.39 506.199 1023.4 506.395C1023.63 509.907 1026.07 513.372 1030.71 516.061C1038.76 520.708 1050.92 521.532 1060.44 518.553H1060.45L1129 499.627C1130.32 499.296 1131.64 498.938 1132.92 498.546L1132.98 498.533C1137.49 497.141 1141.73 495.352 1145.53 493.156C1149.36 490.948 1152.47 488.482 1154.89 485.862L1154.91 485.875L1155.52 485.139C1155.82 484.794 1156.1 484.45 1156.38 484.106L1189.6 443.991L1189.57 443.978C1191.56 441.843 1192.54 439.486 1192.54 437.129L1192.53 437.115ZM1159.55 441.661C1155.19 439.148 1155.19 435.069 1159.55 432.556C1163.91 430.044 1170.97 430.044 1175.32 432.556C1176.55 433.265 1177.39 434.103 1177.93 434.988L1160.45 442.087C1160.15 441.945 1159.83 441.823 1159.55 441.661ZM1056.35 510.353C1052 512.866 1044.94 512.866 1040.58 510.353C1036.22 507.84 1036.22 503.761 1040.58 501.248C1044.94 498.736 1052 498.736 1056.35 501.248C1060.71 503.761 1060.71 507.84 1056.35 510.353Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.2 418.804C1176.95 414.042 1164.41 413.299 1154.79 416.548L1154.75 416.528L1086.15 435.433C1085.49 435.602 1084.84 435.785 1084.19 435.974L1083 436.305L1083.02 436.318C1078.48 437.71 1074.21 439.513 1070.39 441.722C1066.59 443.917 1063.48 446.362 1061.08 448.969L1061.05 449.003C1060.35 449.759 1059.72 450.536 1059.14 451.32L1026.84 490.394L1026.86 490.407C1021.18 495.966 1022.45 503.241 1030.72 508.016C1038.77 512.663 1050.92 513.487 1060.45 510.508H1060.45L1129.01 491.583C1130.33 491.252 1131.64 490.894 1132.93 490.502L1132.99 490.488C1137.5 489.097 1141.73 487.307 1145.54 485.112C1149.37 482.903 1152.48 480.438 1154.9 477.817L1154.92 477.831L1155.52 477.094C1155.82 476.75 1156.11 476.405 1156.38 476.061L1189.61 435.947L1189.58 435.933C1194.69 430.442 1193.23 423.458 1185.21 418.824L1185.2 418.804ZM1056.35 502.295C1052 504.808 1044.94 504.808 1040.58 502.295C1036.22 499.782 1036.22 495.703 1040.58 493.19C1044.94 490.678 1052 490.678 1056.35 493.19C1060.71 495.703 1060.71 499.782 1056.35 502.295ZM1175.32 433.61C1170.97 436.122 1163.91 436.122 1159.55 433.61C1155.19 431.097 1155.19 427.017 1159.55 424.505C1163.91 421.992 1170.97 421.992 1175.32 424.505C1179.68 427.017 1179.68 431.097 1175.32 433.61Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.46 443.079C1158.41 453.441 1158.41 470.245 1140.46 480.607C1122.52 490.968 1093.41 490.968 1075.47 480.607C1057.52 470.245 1057.52 453.441 1075.47 443.079C1093.41 432.718 1122.52 432.718 1140.46 443.079Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.01 465.187V367.289H1153.93V461.843",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.01 465.187V367.289H1153.93V461.843",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.46 348.525C1158.41 358.886 1158.41 375.691 1140.46 386.052C1122.52 396.413 1093.41 396.413 1075.47 386.052C1057.52 375.691 1057.52 358.886 1075.47 348.525C1093.41 338.164 1122.52 338.164 1140.46 348.525Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.66 346.661C1146.31 354.536 1146.31 367.309 1132.66 375.184C1119.02 383.06 1096.91 383.06 1083.26 375.184C1069.62 367.309 1069.62 354.536 1083.26 346.661C1096.91 338.785 1119.02 338.785 1132.66 346.661Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.47 480.607C1093.41 490.968 1122.52 490.968 1140.46 480.607C1149.44 475.426 1153.93 468.631 1153.93 461.843V415.292C1149.03 455.561 1096.72 477.466 1062 457.277V461.843C1062 468.638 1066.48 475.426 1075.46 480.607H1075.47Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M635.888 458.79C634.976 458.79 634.24 458.053 634.24 457.142V445.585C634.24 443.505 635.058 441.843 636.489 441.019C637.915 440.195 639.765 440.317 641.569 441.357L643.082 442.228C643.872 442.681 644.142 443.694 643.683 444.484C643.23 445.274 642.217 445.545 641.427 445.085L639.914 444.214C639.171 443.788 638.509 443.66 638.137 443.876C637.766 444.092 637.543 444.727 637.543 445.585V457.142C637.543 458.053 636.8 458.79 635.895 458.79H635.888Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M653.869 436.919C653.801 436.879 653.727 436.838 653.659 436.798L653.551 436.737C652.112 436.035 650.187 436.19 648.073 437.413C643.622 439.979 640.016 446.234 640.016 451.374C640.016 454.022 640.975 455.845 642.508 456.656L673.442 474.528L684.857 454.825L653.875 436.919H653.869Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M687.479 460.181C687.479 465.321 683.872 471.569 679.421 474.142C674.97 476.709 671.363 474.629 671.363 469.489C671.363 464.349 674.97 458.101 679.421 455.528C683.872 452.954 687.479 455.041 687.479 460.181Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M654.91 463.835C654.072 462.836 653.573 461.35 653.573 459.445C653.573 454.197 657.254 447.814 661.799 445.193C663.522 444.201 665.116 443.903 666.433 444.187L663.826 442.681C663.758 442.64 663.684 442.6 663.616 442.559L663.508 442.499C662.069 441.796 660.151 441.951 658.03 443.174C653.579 445.747 649.973 451.995 649.973 457.135C649.973 459.783 650.932 461.606 652.465 462.417L654.91 463.835Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M687.478 488.745C686.566 488.745 685.83 488.009 685.83 487.097V475.372C685.83 472.852 683.986 469.664 681.805 468.401L678.597 466.551C677.806 466.098 677.536 465.085 677.995 464.295C678.448 463.505 679.461 463.234 680.251 463.694L683.46 465.544C686.641 467.381 689.133 471.697 689.133 475.372V487.097C689.133 488.009 688.397 488.745 687.485 488.745H687.478Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M949.544 439.938C950.456 439.938 951.192 439.202 951.192 438.29V426.734C951.192 424.653 950.374 422.992 948.943 422.168C947.517 421.344 945.667 421.465 943.863 422.505L942.35 423.377C941.56 423.829 941.29 424.842 941.749 425.633C942.202 426.423 943.215 426.693 944.005 426.234L945.518 425.362C946.261 424.937 946.923 424.809 947.295 425.025C947.666 425.241 947.889 425.876 947.889 426.734V438.29C947.889 439.202 948.632 439.938 949.537 439.938H949.544Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M931.563 418.068C931.63 418.027 931.705 417.987 931.772 417.946L931.88 417.886C933.319 417.183 935.237 417.338 937.358 418.561C941.809 421.128 945.416 427.382 945.416 432.522C945.416 435.17 944.457 436.994 942.923 437.804L911.989 455.676L900.574 435.974L931.556 418.068H931.563Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M897.951 441.33C897.951 446.47 901.558 452.718 906.009 455.291C910.46 457.857 914.067 455.777 914.067 450.637C914.067 445.497 910.46 439.25 906.009 436.676C901.558 434.11 897.951 436.19 897.951 441.33Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M930.523 444.984C931.36 443.984 931.86 442.498 931.86 440.593C931.86 435.345 928.179 428.962 923.633 426.342C921.911 425.349 920.317 425.052 919 425.335L921.607 423.829C921.675 423.789 921.749 423.748 921.817 423.708L921.925 423.647C923.363 422.944 925.288 423.1 927.402 424.322C931.853 426.889 935.46 433.143 935.46 438.283C935.46 440.931 934.501 442.755 932.968 443.565L930.523 444.984Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M897.954 469.894C898.865 469.894 899.602 469.158 899.602 468.246V456.52C899.602 454.001 901.446 450.813 903.627 449.55L906.835 447.699C907.626 447.247 907.896 446.234 907.437 445.443C906.984 444.653 905.971 444.383 905.181 444.842L901.972 446.693C898.791 448.53 896.299 452.846 896.299 456.52V468.246C896.299 469.158 897.035 469.894 897.947 469.894H897.954Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M931.811 262.298C932.723 262.298 933.459 261.562 933.459 260.65V249.094C933.459 247.013 932.642 245.352 931.21 244.528C929.785 243.704 927.934 243.825 926.131 244.865L924.618 245.737C923.828 246.189 923.558 247.202 924.017 247.993C924.469 248.783 925.483 249.053 926.273 248.594L927.786 247.722C928.529 247.297 929.191 247.169 929.562 247.385C929.934 247.601 930.157 248.236 930.157 249.094V260.65C930.157 261.562 930.899 262.298 931.805 262.298H931.811Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M913.824 240.421C913.892 240.38 913.966 240.34 914.034 240.299L914.142 240.239C915.58 239.536 917.499 239.692 919.62 240.914C924.071 243.481 927.677 249.735 927.677 254.875C927.677 257.523 926.718 259.347 925.185 260.157L894.251 278.029L882.836 258.327L913.818 240.421H913.824Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M880.215 263.69C880.215 268.83 883.822 275.077 888.273 277.651C892.724 280.217 896.33 278.137 896.33 272.997C896.33 267.857 892.724 261.609 888.273 259.036C883.822 256.469 880.215 258.55 880.215 263.69Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M912.784 267.343C913.622 266.344 914.122 264.858 914.122 262.953C914.122 257.705 910.441 251.322 905.895 248.702C904.173 247.709 902.579 247.412 901.262 247.695L903.869 246.189C903.936 246.149 904.011 246.108 904.078 246.068L904.186 246.007C905.625 245.304 907.55 245.46 909.664 246.682C914.115 249.249 917.722 255.503 917.722 260.643C917.722 263.291 916.763 265.114 915.23 265.925L912.784 267.343Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M880.223 292.247C881.135 292.247 881.871 291.511 881.871 290.599V278.873C881.871 276.354 883.715 273.166 885.897 271.903L889.105 270.052C889.895 269.6 890.165 268.587 889.706 267.796C889.254 267.006 888.24 266.736 887.45 267.195L884.242 269.046C881.061 270.883 878.568 275.199 878.568 278.873V290.599C878.568 291.511 879.305 292.247 880.216 292.247H880.223Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M410.533 285.83C409.621 285.83 408.885 285.094 408.885 284.182V272.626C408.885 270.546 409.702 268.884 411.134 268.06C412.559 267.236 414.41 267.358 416.213 268.398L417.726 269.269C418.516 269.722 418.786 270.735 418.327 271.525C417.875 272.315 416.862 272.585 416.071 272.126L414.558 271.255C413.815 270.829 413.153 270.701 412.782 270.917C412.41 271.133 412.188 271.768 412.188 272.626V284.182C412.188 285.094 411.445 285.83 410.54 285.83H410.533Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M428.519 263.96C428.451 263.92 428.377 263.879 428.31 263.839L428.201 263.778C426.763 263.075 424.845 263.231 422.724 264.453C418.273 267.02 414.666 273.274 414.666 278.414C414.666 281.062 415.625 282.886 417.158 283.696L448.093 301.568L459.507 281.866L428.526 263.96H428.519Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M462.123 287.222C462.123 292.362 458.517 298.61 454.066 301.183C449.615 303.756 446.008 301.669 446.008 296.529C446.008 291.389 449.615 285.142 454.066 282.568C458.517 279.995 462.123 282.082 462.123 287.222Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M429.56 290.883C428.723 289.883 428.223 288.397 428.223 286.492C428.223 281.244 431.904 274.861 436.45 272.241C438.172 271.248 439.766 270.951 441.083 271.234L438.476 269.728C438.408 269.688 438.334 269.647 438.267 269.607L438.159 269.546C436.72 268.843 434.802 268.999 432.681 270.221C428.23 272.788 424.623 279.042 424.623 284.182C424.623 286.83 425.582 288.654 427.115 289.464L429.56 290.883Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M462.123 315.786C461.211 315.786 460.475 315.05 460.475 314.138V302.412C460.475 299.893 458.631 296.705 456.449 295.442L453.241 293.591C452.451 293.139 452.181 292.126 452.64 291.335C453.092 290.545 454.106 290.275 454.896 290.734L458.104 292.585C461.285 294.422 463.778 298.738 463.778 302.412V314.138C463.778 315.05 463.041 315.786 462.13 315.786H462.123Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M604.374 477.107C603.462 477.107 602.719 476.364 602.719 475.453V463.849C602.719 461.762 603.543 460.094 604.975 459.263C606.407 458.439 608.264 458.56 610.074 459.6L611.587 460.478C612.377 460.938 612.647 461.951 612.195 462.741C611.736 463.531 610.723 463.808 609.932 463.349L608.419 462.471C607.676 462.045 607.008 461.917 606.636 462.133C606.265 462.349 606.042 462.991 606.042 463.849V475.453C606.042 476.364 605.299 477.107 604.387 477.107H604.374Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M622.428 455.149C622.361 455.109 622.287 455.068 622.219 455.028L622.111 454.967C620.666 454.258 618.741 454.42 616.613 455.649C612.142 458.229 608.521 464.504 608.521 469.665C608.521 472.319 609.487 474.156 611.027 474.967L642.09 492.913L653.552 473.13L622.442 455.149H622.428Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M656.169 478.506C656.169 483.666 652.549 489.941 648.078 492.521C643.607 495.101 639.986 493.007 639.986 487.847C639.986 482.687 643.607 476.412 648.078 473.832C652.549 471.252 656.169 473.346 656.169 478.506Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M623.476 482.18C622.632 481.174 622.132 479.688 622.132 477.769C622.132 472.501 625.833 466.091 630.393 463.457C632.122 462.458 633.722 462.16 635.046 462.451L632.432 460.938C632.365 460.897 632.29 460.857 632.223 460.816L632.115 460.756C630.669 460.046 628.745 460.208 626.617 461.438C622.146 464.018 618.525 470.293 618.525 475.453C618.525 478.107 619.491 479.944 621.031 480.755L623.49 482.18H623.476Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M656.17 507.185C655.259 507.185 654.516 506.442 654.516 505.53V493.757C654.516 491.231 652.665 488.023 650.477 486.76L647.255 484.902C646.465 484.443 646.194 483.43 646.647 482.64C647.106 481.843 648.119 481.572 648.91 482.032L652.131 483.889C655.326 485.733 657.825 490.069 657.825 493.757V505.53C657.825 506.442 657.082 507.185 656.17 507.185Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M129.524 284.466C128.612 284.466 127.869 283.723 127.869 282.811V271.207C127.869 269.12 128.693 267.452 130.125 266.621C131.557 265.797 133.414 265.919 135.224 266.959L136.737 267.837C137.528 268.296 137.798 269.309 137.345 270.1C136.886 270.897 135.873 271.167 135.083 270.708L133.57 269.83C132.827 269.404 132.158 269.276 131.787 269.492C131.415 269.708 131.192 270.35 131.192 271.207V282.811C131.192 283.723 130.449 284.466 129.537 284.466H129.524Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M147.575 262.508C147.507 262.467 147.433 262.427 147.366 262.386L147.257 262.325C145.812 261.616 143.887 261.778 141.76 263.008C137.288 265.588 133.668 271.863 133.668 277.023C133.668 279.677 134.634 281.515 136.174 282.325L167.237 300.272L178.698 280.488L147.588 262.508H147.575Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M181.322 285.864C181.322 291.025 177.702 297.299 173.23 299.879C168.759 302.46 165.139 300.366 165.139 295.205C165.139 290.045 168.759 283.771 173.23 281.19C177.702 278.61 181.322 280.704 181.322 285.864Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M148.625 289.532C147.78 288.525 147.281 287.039 147.281 285.121C147.281 279.853 150.982 273.443 155.541 270.809C157.27 269.809 158.871 269.512 160.195 269.802L157.581 268.289C157.513 268.249 157.439 268.208 157.371 268.168L157.263 268.107C155.818 267.398 153.893 267.56 151.765 268.789C147.294 271.369 143.674 277.644 143.674 282.804C143.674 285.459 144.64 287.296 146.18 288.106L148.638 289.532H148.625Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M181.323 314.536C180.411 314.536 179.668 313.793 179.668 312.881V301.109C179.668 298.583 177.817 295.374 175.629 294.111L172.407 292.254C171.617 291.795 171.347 290.782 171.799 289.991C172.259 289.194 173.272 288.924 174.062 289.383L177.284 291.241C180.478 293.085 182.978 297.421 182.978 301.109V312.881C182.978 313.793 182.235 314.536 181.323 314.536Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M161.444 328.045C160.532 328.045 159.789 327.302 159.789 326.39V314.787C159.789 312.7 160.613 311.031 162.045 310.201C163.477 309.377 165.334 309.498 167.144 310.545L168.657 311.423C169.448 311.882 169.718 312.896 169.265 313.686C168.806 314.483 167.793 314.753 167.003 314.294L165.483 313.416C164.74 312.99 164.071 312.862 163.7 313.078C163.328 313.294 163.105 313.936 163.105 314.793V326.397C163.105 327.309 162.362 328.052 161.451 328.052L161.444 328.045Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M179.499 306.087C179.431 306.047 179.357 306.006 179.289 305.966L179.181 305.905C177.736 305.195 175.811 305.358 173.683 306.587C169.212 309.167 165.592 315.442 165.592 320.602C165.592 323.257 166.558 325.094 168.098 325.904L199.16 343.851L210.622 324.067L179.512 306.087H179.499Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M213.236 329.444C213.236 334.604 209.616 340.878 205.144 343.459C200.673 346.039 197.053 343.945 197.053 338.785C197.053 333.624 200.673 327.35 205.144 324.77C209.616 322.189 213.236 324.283 213.236 329.444Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M180.547 333.111C179.702 332.104 179.202 330.618 179.202 328.7C179.202 323.432 182.904 317.022 187.463 314.388C189.192 313.388 190.793 313.091 192.117 313.382L189.503 311.869C189.435 311.828 189.361 311.788 189.293 311.747L189.185 311.686C187.74 310.977 185.808 311.139 183.687 312.369C179.216 314.949 175.596 321.223 175.596 326.384C175.596 329.038 176.562 330.875 178.102 331.686L180.56 333.111H180.547Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M213.237 358.116C212.325 358.116 211.582 357.373 211.582 356.461V344.688C211.582 342.162 209.731 338.954 207.543 337.691L204.321 335.833C203.531 335.374 203.261 334.361 203.713 333.571C204.173 332.774 205.186 332.504 205.976 332.963L209.198 334.82C212.393 336.664 214.892 341 214.892 344.688V356.461C214.892 357.373 214.149 358.116 213.237 358.116Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M174.386 374.941V376.015L153.164 388.267V387.193L174.386 374.941Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M149.43 399.818L184.146 419.554V388.774L149.43 369.038V399.818Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M149.43 369.038L184.146 388.774L226.752 364.175L192.042 344.439L149.43 369.038Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M226.752 364.175V394.954L184.146 419.554V388.774L226.752 364.175Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M218.101 399.959L226.523 404.823L205.308 417.075L196.879 412.212L218.101 399.959Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M196.879 412.212L218.101 399.959V377.285L196.879 389.537V412.212Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M949.555 291.774L992.363 316.495V267.06L949.555 242.339V291.774Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M992.363 316.496L1001.15 311.531V262.103L992.363 267.06V316.496Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M949.555 242.339L958.335 237.382L1001.15 262.102L992.363 267.06L949.555 242.339Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M949.555 269.357L992.363 294.071V284.304L949.555 259.583V269.357Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M992.363 294.071L1001.15 289.113V279.347L992.363 284.304V294.071Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M919.984 307.816L962.799 332.53V283.095L919.984 258.381V307.816Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M962.801 332.53L971.581 327.573V278.138L962.801 283.095V332.53Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M919.984 258.381L928.772 253.423L971.58 278.137L962.799 283.095L919.984 258.381Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M919.984 285.398L962.799 310.113V300.346L919.984 275.625V285.398Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M962.801 310.112L971.581 305.155V295.381L962.801 300.346V310.112Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M471.127 510.022L428.17 534.824V485.213L471.127 460.418V510.022Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M428.168 534.824L419.354 529.846V480.242L428.168 485.213V534.824Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M471.125 460.418L462.31 455.44L419.354 480.242L428.168 485.213L471.125 460.418Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M444.771 449.428C444.98 449.786 445.129 450.225 445.129 450.806C445.129 452.772 443.751 455.156 442.049 456.142C441.508 456.453 441.022 456.527 440.576 456.5C441.083 457.365 442.096 457.594 443.298 456.905C445 455.926 446.378 453.535 446.378 451.57C446.378 450.232 445.716 449.496 444.771 449.435V449.428Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M453.768 438.473L429.081 452.725L420.436 466.166V479.621L462.312 455.447L462.373 441.958L453.768 438.48V438.473ZM443.299 456.845C441.624 457.811 440.266 457.027 440.266 455.095C440.266 453.164 441.624 450.813 443.299 449.847C444.974 448.881 446.331 449.665 446.331 451.597C446.331 453.528 444.974 455.879 443.299 456.845Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M471.127 487.523L428.17 512.325V502.518L471.127 477.716V487.523Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M428.168 512.325L419.354 507.347V497.547L428.168 502.518V512.325Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneControl13Dark);
export default __webpack_public_path__ + "static/media/ZoneControl13Dark.788c82a5bca9afacaf124753db2d1be0.svg";
export { ForwardRef as ReactComponent };